/* eslint-disable @typescript-eslint/no-unused-vars */

import Header from "../components/header";
import { useNavigate } from "react-router";
import ExampleCard from "@src/components/example_card";
import { ToastContainer } from "react-toastify";

import Login from "./components/Login";

export default function LoginPage() {
    const navigatePage = useNavigate();
    
    return (
        <div className="w-full h-screen flex overflow-hidden bg-gray-50">
            {/* Left Side - Login Form */}
            <div className="w-full lg:w-1/2 flex items-center justify-center p-8 lg:p-12 overflow-y-auto">
                <div className="w-full max-w-md">
                    <Login 
                        handleForgetPasssword={() => navigatePage("/auth/forgot_password")}
                        handleCreateAccount={() => navigatePage("/auth/signup")}
                    /> 
                </div>
            </div>

            {/* Right Side - Branding/Image */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-[#E55109] to-[#FF8C42] items-center justify-center p-12 relative overflow-hidden">
                <div className="absolute inset-0 bg-[url('/pattern.svg')] opacity-10"></div>
                <div className="relative z-10 text-white text-center max-w-lg">
                    <div className="mb-8">
                        <div className="w-24 h-24 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mx-auto mb-6">
                            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                            </svg>
                        </div>
                    </div>
                    <h1 className="text-4xl font-bold mb-4">Welcome to GMind Admin</h1>
                    <p className="text-lg text-white/90 mb-8">
                        Manage your educational platform with powerful AI-driven tools and insights.
                    </p>
                    <div className="grid grid-cols-2 gap-4 text-left">
                        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                            <div className="text-3xl font-bold mb-1">10K+</div>
                            <div className="text-sm text-white/80">Active Users</div>
                        </div>
                        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                            <div className="text-3xl font-bold mb-1">500+</div>
                            <div className="text-sm text-white/80">Schools</div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </div>
    )
}
